export default function Advantage({ src, alt, text }) {
    return (<div className="flex p-2 px-5 flex-row gap-4 items-center justify-start bg-[rgba(255,255,255,0.45)] border border-[#B5ADFF] font-bold leading-5 hue-rotate-effect">
        <img src={src} alt={alt} />
        <p>{text}</p>
    </div>)
}